<template>
  <v-card>
    <v-card id="todo_drawer_height">
      <v-app-bar height="50">
        <v-row align="center" justify="space-between" class="ma-0">
          <h2 v-if="drawerType === 'schedule'">选择场次</h2>
          <h2 v-else-if="drawerType === 'student'">选择学生</h2>
          <v-btn small color="error" @click.stop="closeTodoDrawer">关闭</v-btn>
        </v-row>
      </v-app-bar>
      <v-card-text id="TodoDrawerCardText" class="pa-0 pr-4 pl-4">
        <v-form ref="form" lazy-validation>
          <v-select
            v-model="selectedSemester"
            @change="changeSemester"
            :items="semesters"
            :rules="[v => !!v || '学期不能为空']"
            label="学期"
            item-text="name"
            item-value="id"
            hideDetails
            required
            class="ma-0 mt-5 pa-0"
          ></v-select>
          <v-row v-if="drawerType === 'schedule'" class="ma-0">
            <v-col class="pa-0">
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    v-on="on"
                    label="开始日期"
                    prepend-icon="mdi-calendar"
                    hideDetails
                    readonly
                    clearable
                    @click:clear="
                      () => {
                        startDate = null;
                        refresh();
                      }
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  locale="zh-cn"
                  @change="refresh"
                  @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pa-0">
              <v-menu
                v-model="endMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    v-on="on"
                    label="结束日期"
                    prepend-icon="mdi-calendar"
                    hideDetails
                    readonly
                    clearable
                    @click:clear="
                      () => {
                        endDate = null;
                        refresh();
                      }
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  locale="zh-cn"
                  @change="refresh"
                  @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="pa-0">
              <v-combobox
                v-model="course"
                @change="refresh"
                :items="courses"
                label="课程"
                item-text="name"
                item-value="id"
                hideDetails
                clearable
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row v-if="drawerType === 'schedule'" class="ma-0">
            <v-col
              class="pa-0"
              v-if="
                user.role === 'centreadmin' ||
                  user.role === 'teacher' ||
                  user.role === 'assistant'
              "
            >
              <v-combobox
                v-model="teacher"
                @change="refresh"
                :items="teachers"
                label="教师"
                item-text="name"
                item-value="id"
                hideDetails
                clearable
              ></v-combobox>
            </v-col>
            <v-col class="pa-0">
              <v-combobox
                v-model="scheduleExperiment"
                @change="refresh"
                :items="scheduleExperiments"
                label="实验"
                item-text="name"
                item-value="id"
                hideDetails
                clearable
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row
            v-if="drawerType === 'student' && !this.grade && !this.codeOrName"
            class="ma-0"
          >
            <v-col class="pa-0">
              <v-combobox
                v-model="studentExperiment"
                @change="refresh"
                :items="studentExperiments"
                label="实验"
                item-text="name"
                item-value="id"
                hideDetails
                clearable
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row
            v-if="drawerType === 'student' && !this.studentExperiment"
            class="ma-0"
          >
            <v-col class="pa-0">
              <v-combobox
                v-model="grade"
                @change="refresh"
                :items="grades"
                label="班级"
                item-text="name"
                item-value="id"
                hideDetails
                clearable
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row
            v-if="drawerType === 'student' && !this.studentExperiment"
            class="ma-0"
          >
            <v-col class="pa-0">
              <v-text-field
                v-model="codeOrName"
                placeholder="请输入学号或姓名"
                clearable
                @blur="refresh"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="mt-3 mr-2 mb-3 ml-2"
            align="center"
            justify="space-between"
          >
            <v-row>
              <v-checkbox
                v-model="submitOnly"
                class="mt-0 pa-0"
                label="待批阅"
                hideDetails
                required
              ></v-checkbox>
              <v-checkbox
                v-model="sendbackOnly"
                class="mt-0 pa-0"
                label="已退回"
                hideDetails
                required
              ></v-checkbox>
              <v-checkbox
                class="ml-1 mt-0 pa-0"
                v-model="selectAll"
                label="全选"
                hide-details
                required
                @change="checkAll"
              ></v-checkbox>
            </v-row>
            <v-btn
              v-if="checkboxes.length > 0"
              color="warning"
              @click="submit"
              small
            >
              确定
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card>
      <v-card-text class="pa-0">
        <v-list
          class="pa-0"
          :style="
            `height: calc(100vh - ${todoDrawerHeight}px) !important; overflow-y: auto`
          "
        >
          <v-list-item-group multiple active-class="primary--text">
            <virtual-list
              :data-key="'id'"
              :data-sources="filterData"
              :data-component="itemComponent"
              :extra-props="{
                submitOnly,
                sendbackOnly,
                checkboxes,
                onItemSelect: select
              }"
              :style="
                `height: calc(100vh - ${todoDrawerHeight}px) !important; overflow-y: auto`
              "
            >
            </virtual-list>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import virtualList from 'vue-virtual-scroll-list';
import { mapActions, mapGetters } from 'vuex';
import api from '../api';
import TodoItem from './TodoItem';

export default {
  data() {
    return {
      itemComponent: TodoItem,
      selectAll: false,
      selectedSemester: '',
      startMenu: false,
      endMenu: false,
      startDate: null,
      endDate: null,
      teacher: '',
      course: '',
      scheduleExperiments: [],
      scheduleExperiment: '',
      studentExperiments: [],
      studentExperiment: '',
      grade: '',
      grades: [],
      codeOrName: '',
      submitOnly: false,
      sendbackOnly: false,
      checkedDatas: [],
      checkboxes: [],
      todoDrawerHeight: 0
    };
  },
  components: {
    'virtual-list': virtualList
  },
  computed: {
    ...mapGetters([
      'config',
      'user',
      'curUser',
      'semester',
      'semesters',
      'teachers',
      'courses',
      'lessons',
      'students',
      'orgs',
      'experiments',
      'drawerType'
    ]),
    filterData() {
      if (this.drawerType === 'schedule') {
        if (this.submitOnly && this.sendbackOnly) {
          return this.lessons.filter(
            item => item.rpt_submit > 0 || item.rpt_sendback > 0
          );
        } else if (this.submitOnly) {
          return this.lessons.filter(item => item.rpt_submit > 0);
        } else if (this.sendbackOnly) {
          return this.lessons.filter(item => item.rpt_sendback > 0);
        } else return this.lessons;
      } else if (this.drawerType === 'student') {
        if (this.studentExperiment) {
          if (this.submitOnly && this.sendbackOnly) {
            return this.orgs.filter(
              item => item.rpt_submit > 0 || item.rpt_sendback > 0
            );
          } else if (this.submitOnly) {
            return this.orgs.filter(item => item.rpt_submit > 0);
          } else if (this.sendbackOnly) {
            return this.orgs.filter(item => item.rpt_sendback > 0);
          } else return this.orgs;
        } else {
          if (this.submitOnly && this.sendbackOnly) {
            return this.students.filter(
              item => item.rpt_submit > 0 || item.rpt_sendback > 0
            );
          } else if (this.submitOnly) {
            return this.students.filter(item => item.rpt_submit > 0);
          } else if (this.sendbackOnly) {
            return this.students.filter(item => item.rpt_sendback > 0);
          } else return this.students;
        }
      }
    }
  },
  watch: {
    lessons(val) {
      this.getScheduleExperiments(val, null, null);
    },
    teacher(val) {
      this.scheduleExperiment = '';
      this.getScheduleExperiments(this.lessons, val, null);
    },
    course(val) {
      this.scheduleExperiment = '';
      this.studentExperiment = '';
      this.grade = '';
      this.codeOrName = '';

      if (val) {
        if (this.drawerType === 'schedule')
          this.getScheduleExperiments(this.lessons, null, val);
        else if (this.drawerType === 'student') this.getStudentExperimets(val);

        this.fetchGrades(val.id);
      } else this.grades = [];
    }
  },
  methods: {
    ...mapActions([
      'fetchCourses',
      'fetchProjects',
      'fetchOrgs',
      'afterFetchOrgs',
      'fetchLessons',
      'fetchStudents',
      'afterFetchStudents',
      'selectLessons',
      'selectStudents',
      'selectOrgs',
      'selectCurDrawerType',
      'selectIsOrg',
      'alert'
    ]),
    closeTodoDrawer() {
      this.$store.commit('toggleTodoDrawer', false);
    },
    getStudentExperimets(course) {
      api.getCourseExperiments(
        course.id,
        data => {
          this.studentExperiments = data.map(item => ({
            id: item.projects.id,
            name: item.optional
              ? `${item.projects.name}(选修)`
              : `${item.projects.name}(必修)`
          }));
        },
        err => Promise.reject(err)
      );
    },
    getScheduleExperiments(lessons, teacher, course) {
      this.scheduleExperiments = [];
      if (teacher && course) {
        lessons.forEach(lesson => {
          if (
            lesson.teachers_id === teacher.id &&
            lesson.course_id === course.id
          ) {
            this.scheduleExperiments.push({
              id: lesson.projects.id,
              name: lesson.projects.name
            });
          }
        });
      } else if (teacher) {
        lessons.forEach(lesson => {
          if (lesson.teachers_id === teacher.id) {
            this.scheduleExperiments.push({
              id: lesson.projects.id,
              name: lesson.projects.name
            });
          }
        });
      } else if (course) {
        lessons.forEach(lesson => {
          if (lesson.course_id === course.id) {
            this.scheduleExperiments.push({
              id: lesson.projects.id,
              name: lesson.projects.name
            });
          }
        });
      } else {
        lessons.forEach(lesson => {
          if (this.user.role === 'teacher' && lesson.teacher === this.user.id) {
            this.scheduleExperiments.push({
              id: lesson.projects.id,
              name: lesson.projects.name
            });
          } else {
            this.scheduleExperiments.push({
              id: lesson.projects.id,
              name: lesson.projects.name
            });
          }
        });
      }
    },
    fetchGrades(course_id) {
      if (
        this.user.role === 'teacher' &&
        this.config.allowTeacherManageOwnClass &&
        (!this.curUser.class_list || !this.curUser.class_list.length)
      ) {
        this.grades = [];

        return;
      }

      api.getOrgs(
        {
          semester_id: this.selectedSemester,
          course_id
        },
        grades => {
          let filterGrades = grades;

          if (
            this.user.role === 'teacher' &&
            this.config.allowTeacherManageOwnClass
          )
            filterGrades = filterGrades.filter(item =>
              this.curUser.class_list.some(cl => cl === item.orgs.id)
            );

          this.grades = filterGrades
            .map(item => ({
              id: item.orgs.id,
              name: item.orgs.name
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
        },
        err => Promise.reject(err)
      );
    },
    checkAll(checked) {
      if (checked) {
        if (this.drawerType === 'schedule') {
          this.lessons.forEach(item => {
            if (
              !this.submitOnly ||
              (this.submitOnly && item.rpt_submit > 0) ||
              !this.sendbackOnly ||
              (this.sendbackOnly && item.rpt_sendback > 0)
            ) {
              this.checkboxes.push(item.id);
              this.checkedDatas.push(item);
            }
          });
        } else if (this.drawerType === 'student') {
          if (this.studentExperiment) {
            this.orgs.forEach(item => {
              if (
                !this.submitOnly ||
                (this.submitOnly && item.rpt_submit > 0) ||
                !this.sendbackOnly ||
                (this.sendbackOnly && item.rpt_sendback > 0)
              ) {
                this.checkboxes.push(item.id);
                this.checkedDatas.push(item);
              }
            });
          } else {
            this.students.forEach(item => {
              if (
                !this.submitOnly ||
                (this.submitOnly && item.rpt_submit > 0) ||
                !this.sendbackOnly ||
                (this.sendbackOnly && item.rpt_sendback > 0)
              ) {
                this.checkboxes.push(item.id);
                this.checkedDatas.push(item);
              }
            });
          }
        }
      } else {
        this.checkboxes = [];
        this.checkedDatas = [];
      }
    },
    select(data) {
      const index = this.checkboxes.findIndex(x => x === data.id);
      if (index !== -1) {
        this.checkboxes.splice(index, 1);
        this.checkedDatas.splice(index, 1);
      } else if (this.checkboxes.length > 10) {
        if (this.drawerType === 'schedule')
          this.alert({ message: '一次最多添加十个场次', color: 'error' });
        else if (this.drawerType === 'student')
          this.alert({ message: '一次最多添加十个学生', color: 'error' });
      } else {
        this.checkboxes.push(data.id);
        this.checkedDatas.push(data);
      }
    },
    submit() {
      if (this.drawerType === 'schedule') {
        if (this.checkboxes.length > 10) {
          this.alert({ message: '一次最多添加十个场次', color: 'error' });

          return;
        }

        this.selectLessons(this.checkedDatas);
      } else if (this.drawerType === 'student') {
        if (this.checkboxes.length > 10) {
          this.alert({ message: '一次最多添加十个子项目', color: 'error' });

          return;
        }

        if (this.studentExperiment) {
          this.selectOrgs(this.checkedDatas);
          this.selectIsOrg(true);
        } else {
          this.selectStudents(this.checkedDatas);
          this.selectIsOrg(false);
        }
      }

      this.checkboxes = [];
      this.checkedDatas = [];
      this.selectAll = false;
      this.selectCurDrawerType(this.drawerType);
      this.closeTodoDrawer();
    },
    changeSemester() {
      this.course = '';
      this.scheduleExperiment = '';
      this.studentExperiment = '';
      this.fetchCourses({
        org_id: this.user.org,
        semester_id: this.selectedSemester
      });
      this.fetchProjects({
        org_id: this.user.org,
        semester_id: this.selectedSemester
      });
      this.refresh();
    },
    refresh() {
      this.checkboxes = [];
      this.checkedDatas = [];

      if (this.drawerType === 'schedule') {
        this.fetchLessons({
          semester: this.selectedSemester,
          course: this.course ? this.course && this.course.id : '',
          experiment: this.scheduleExperiment
            ? this.scheduleExperiment && this.scheduleExperiment.id
            : '',
          teacher:
            this.user.role === 'centreadmin' ||
            this.user.role === 'assistant' ||
            (this.user.role === 'teacher' && this.teacher)
              ? this.teacher && this.teacher.id
              : this.user && this.user.id,
          start: this.startDate ? this.startDate : '',
          end: this.endDate ? this.endDate : ''
        }).then(() => {
          if (this.scheduleExperiment) {
            this.$store.commit('setExperiment', this.scheduleExperiment.id);
          }
          this.$store.commit('setLessonOptions', {
            semester: this.selectedSemester,
            experiment: this.scheduleExperiment
              ? this.scheduleExperiment && this.scheduleExperiment.id
              : '',
            teacher:
              this.user.role === 'centreadmin' ||
              this.user.role === 'assistant' ||
              (this.user.role === 'teacher' && this.teacher)
                ? this.teacher && this.teacher.id
                : this.user && this.user.id,
            start: this.startDate ? this.startDate : '',
            end: this.endDate ? this.endDate : ''
          });
        });
      } else if (this.drawerType === 'student') {
        if (this.course && this.studentExperiment) {
          this.fetchOrgs({
            semester_id: this.selectedSemester,
            course_id: this.course.id,
            project_id: this.studentExperiment.id
          }).then(data => {
            this.afterFetchOrgs(data);
            this.$store.commit('setOrgOptions', {
              semester_id: this.selectedSemester,
              course_id: this.course.id,
              project_id: this.studentExperiment.id,
              project_name: this.studentExperiment.name
            });
          });
        } else if (this.grade || this.codeOrName) {
          this.fetchStudents({
            grade: this.grade ? this.grade.id : '',
            codeOrName: this.codeOrName ? this.codeOrName : ''
          }).then(data => {
            this.afterFetchStudents(data);
            this.$store.commit('setStudentOptions', {
              grade: this.grade ? this.grade.id : '',
              codeOrName: this.codeOrName ? this.codeOrName : ''
            });
          });
        }
      }
    },
    getTodoDrawerHeight() {
      this.todoDrawerHeight =
        document.getElementById('todo_drawer_height').offsetHeight + 15;
    }
  },
  mounted() {
    this.selectedSemester = this.semester.id;
    this.refresh();
    this.getTodoDrawerHeight();
  }
};
</script>
